import React from 'react'
import ChoiceInputField from '../ChoiceInputField'

const ChoiceFieldLabel: React.FC = ({children}) => <ChoiceInputField.Label>{children}</ChoiceInputField.Label>

export default ChoiceFieldLabel
